import React from 'react';
import { IBadgeProps } from './types';
import { View, NotificationBadge } from './view';

export type BadgeProps = Omit<IBadgeProps, 'css'>;

export { BadgeStyles } from './styles';

export const Badge = React.forwardRef((props: BadgeProps, ref: any) => {
	return props.isNotification ? (
		<NotificationBadge rootref={ref} {...props} />
	) : (
		<View rootref={ref} {...props}>
			{props.children}
		</View>
	);
});
